export enum InterestRateType {
  FIXED = "FIXED",
  VARIABLE = "VARIABLE"
}
